import React, { useState, useEffect, forwardRef } from 'react';
import { Avatar } from "@material-ui/core";
import "./Post.css";
import ThumbUpAltIcon from "@material-ui/icons/ThumbUpAlt";
import CommentIcon from "@material-ui/icons/Comment";
import firebase from "firebase";
import { db } from "../firebase";
import { Link } from "react-router-dom";
import DeleteIcon from "@material-ui/icons/Delete";

const Post = forwardRef(({ postId, username, photoURL, caption, imageUrl, likes, uid, timestamp }, ref) => {
    const user = firebase.auth().currentUser;
    const [comments, setComments] = useState([]);
    const [comment, setComment] = useState('');
    const [likeInIcon, setLikeInIcon] = useState("iconLight");
    const [likeInText, setLikeInText] = useState("textLight");
    const [likedUsers, setLikedUsers] = useState();
    const [liked, setLiked] = useState(false);

    const deletePost = (e) => {
        e.preventDefault();
        db.collection("posts").doc(postId).delete();
    }

    useEffect(() => {
        let unsubscribe;
        if (postId) {
            unsubscribe = db
            .collection("posts")
            .doc(postId)
            .collection("comments")
            .orderBy('timestamp', 'desc')
            .onSnapshot((snapshot) => {
                setComments(snapshot.docs.map((docs) => docs.data()));
            });
        }

        return () => {
            unsubscribe();
        };
    }, [postId]);

    if (user === false) {
        document.getElementsByClassName("post_commment_input")[0].style.display = "none"
    }


    const postComment = (event) => {
        event.preventDefault();

        db.collection("posts").doc(postId).collection("comments").add({
            text: comment,
            username: user.displayName,
            timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
        setComment('');
    }

    useEffect(() => {
        db.collection("posts").doc(postId).collection("postLikes").onSnapshot((snapy) => {
            setLikedUsers(snapy.docs.map((docy) => {
                if (docy?.id === user?.uid) {
                    setLikeInIcon("iconLight blue")
                    setLikeInText("textLight blue")
                } else {
                    setLikeInIcon("iconLight")
                    setLikeInText("textLight")
                }
            }))
        })
    }, [likeInIcon, postId, user?.uid])

    const handleLike = (e) => {
        e.preventDefault();
        if (likeInIcon === "iconLight") {
            setLikeInIcon("iconLight blue")
            setLikeInText("textLight blue")
        } else {
            setLikeInIcon("iconLight")
            setLikeInText("textLight")
        }
        db.collection("posts").doc(postId).get().then((doc2) => {
            const data = doc2.data();
            console.log(likeInIcon)
            if (likeInIcon === "iconLight") {
                db.collection("posts").doc(postId).collection("postLikes").doc(user.uid).get().then((doc3) => {
                    if (doc3.data()) {
                        console.log(doc3.data())
                    } else {
                        db.collection("posts").doc(postId).collection("postLikes").doc(user.uid).set({
                            likes: 1
                        });
                        db.collection("posts").doc(postId).update({
                            likes: data.likes + 1
                        })
                    }
                })
            } else {
                db.collection("posts").doc(postId).collection("postLikes").doc(user.uid).delete().then(function () {
                    db.collection("posts").doc(postId).update({
                        likes: data.likes - 1
                    }).then(function () {
                        window.location.reload(true);
                    })
                })
            }
        })
    }

    return (
        <div className="post" ref={ref}>
            <Link className="linkToSendersProfile" to={`/${username}/${uid}`}>
            <div className="post__header">
                <Avatar src={photoURL} />
                <div className="post__senderNameAndTimestamp">
                    <h3>{username}</h3>
                    <p>{new Date(timestamp?.toDate()).toUTCString()}</p>
                </div>
            </div>
            </Link>
            <div className="post__body">
                <div className="post__description">
                    <p>{caption}</p>
                </div>
                <div className="post__image">
                    <img src={imageUrl} alt="" />
                </div>
                <div className="post__likes">
                    <ThumbUpAltIcon style={{ color: "blue" }}/>
                    <p>{`${likes} ${likes === 1 ? "like" : "likes"}`}</p>
                </div>
                {
                    user && (
                        <div className="post__footer">
                            <div onClick={handleLike} className="post_footer_options like">
                                <ThumbUpAltIcon className={likeInIcon}/>
                                <h5 className={likeInText}>Like</h5>
                            </div>
                            {
                                uid === user?.uid && (
                                    <div onClick={deletePost} className="post_footer_options delete">
                                        <DeleteIcon />
                                        <h5>Delete</h5>
                                    </div>
                                )
                            }
                            <div className="post_footer_options">
                                <CommentIcon />
                                <h5>Comment</h5>
                            </div>
                        </div>
                    )
                }
                <div className="post__comments">
                    {
                        user && (
                        <div className="post_commment_input">
                            <Avatar src={user?.photoURL} />
                            <input placeholder="Write a comment" value={comment} onChange={(e) => setComment(e.target.value)} />
                            <button disabled={!comment} type="submit" className="hidden_button" onClick={postComment}>Post</button>
                    </div>
                        )
                    }
                    <div className="post_comment_comments">
                    {comments.map((comment) => (
            <p>
                <strong>{comment.username}:</strong> {comment.text}
            </p>
        ))}
                    </div>
                </div>
            </div>
        </div>
    )
})

export default Post;